define('drops/dropField/dropField',[
    'jquery',
    'lq/drop',
    'lq/style',
    'underscore',
    'when'
], function ($, Drop, Style, _, when) {
    'use strict';

    var fileDroppedEvent = 'fileDropped';

    function DropField(options) {
        Drop.call(this, $('<div />'), null, options);

        Style.renderStyles(this, null, this.$element);
    };

    Drop.extend(DropField, Drop);

    DropField.typeName = 'DropField';

    DropField.prototype.preRender = function () {
        this.applyPosition();

        this.preventDefaultEventHandlers();

        if (this.isEventEnabled(fileDroppedEvent)) {
            this.addDropEventHandler();
        }
    };

    DropField.prototype.preventDefaultEventHandlers = function () {
        this.$element.on('dragover', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
        this.$element.on('dragenter', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
        this.$element.on('dragleave', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
    };

    DropField.prototype.addDropEventHandler = function () {
        var self = this;
        this.$element.on('drop', function (e) {
            var dataTransfer = e.originalEvent.dataTransfer;
            if (!dataTransfer || !dataTransfer.files.length) return;

            e.preventDefault();
            e.stopPropagation();

            var files = Array.prototype.slice.call(dataTransfer.files);
            var raisedEventName = self.data.eventing[fileDroppedEvent].raisedEventName;

            if (!!self.data.notTriggerEventOnEveryFile) {
                if (files.length === 1) {
                    self.storeFileNameInParameter(files[0].name);
                    self.triggerEvent(raisedEventName, files[0]);
                } else {
                    self.storeFileNameInParameter(_.pluck(files, 'name'));
                    self.triggerEvent(raisedEventName, files);
                }
            } else {
                when.reduce(files, function (options, file) {
                    if (options && options.break) return options;

                    self.storeFileNameInParameter(file.name);
                    var deferred = when.defer();
                    self.triggerEvent(
                        raisedEventName, file,
                        undefined, undefined, undefined, undefined,
                        deferred.resolve
                    );
                    return deferred.promise;
                }, undefined);
            }
        });
    };

    DropField.prototype.storeFileNameInParameter = function (filenName) {
        if (!!this.data.fileNameParameter) {
            var targetParameters = this.data.fileNameParameterIsGlobal
                ? this.piping.parameters.globals
                : this.piping.parameters.locals;
            targetParameters.setValue(this.data.fileNameParameter, filenName);
        }
    };

    return DropField;
});
